// Le sens de lecture pour les composants Radix. Sans fournisseur, Tabs, Select, menus et
// infobulles se déclarent `dir="ltr"` eux-mêmes : en arabe, tout l'intérieur d'un onglet
// (réglages, équipe, plan) restait aligné à gauche dans une page déjà passée en `rtl`.
// L'application fournit la direction de la langue une fois à la racine.
import { Direction } from "radix-ui"

export const DirectionProvider = Direction.DirectionProvider
